import React from "react";

const CarNotificaciones = ({ cuerpoMensaje, urlImagen, fecha, toUser, unidad }) => {
    fecha = new Date(fecha)
    let onlyFecha = fecha.toLocaleString().split(',');
    if (onlyFecha.length === 1) {
      onlyFecha = fecha.toLocaleString().split(' ');
    }
    let publico_meta = null;
    let mensaje = cuerpoMensaje.replace(/\n\n/g, '<br><br>');
    toUser.trim() === 'Docente' ? publico_meta = 'Catedráticos' : publico_meta = toUser; 

    const alertaBody = ()=>{
        return {__html: mensaje};
    }

  return (
    <div className="card mb-3">
      <div className="card-body">
        <div className="d-flex align-items-center flex-wrap mb-2">
          {unidad ? (
            <span className="esen-chip esen-chip--info mr-2 mb-1">{unidad}</span>
          ) : null}
          {publico_meta ? (
            <span className="esen-chip esen-chip--neutral mb-1">Para: {publico_meta}</span>
          ) : null}
        </div>
        <p className="mb-2" dangerouslySetInnerHTML={alertaBody()}></p>
        {urlImagen ? (
          <img
            src={urlImagen}
            className="rounded mx-auto d-block w-25 mb-2"
            alt="Imagen de la notificación"
          />
        ) : null}
        <small className="text-muted d-block">
          <i className="fa fa-clock-o mr-1" aria-hidden="true"></i>
          Publicado el {onlyFecha[0]}
        </small>
      </div>
    </div>
  );
};

export default CarNotificaciones;
